var map = {
	"./cert-E-commerce-cpttm.jpg": 281,
	"./cert-customer-cpttm.jpg": 282,
	"./cert-finance-cpttm.jpg": 284,
	"./cert-fsi-cpttm.jpg": 286,
	"./cert-general-staff-a-cpttm.jpg": 288,
	"./cert-general-staff-cpttm.jpg": 290,
	"./cert-general2024-cpttm.jpg": 220,
	"./cert-hr-cpttm.jpg": 291,
	"./cert-it-cpttm.jpg": 292,
	"./cert-market-cpttm.jpg": 293,
	"./cert-ngo-cpttm.jpg": 294,
	"./cert-senior-manager-cpttm.jpg": 296,
	"./cert-startup-cpttm.jpg": 297,
	"./cert-student-cpttm.jpg": 299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2939;